const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL || '/api'}/transcription`;

const transcriptionAPI = {
  async transcribeAudio(audioBlob, { model = 'gpt-4o-transcribe', responseFormat = 'text' } = {}) {
    try {
      const formData = new FormData();
      const mimeType = (audioBlob && audioBlob.type) || 'audio/webm';
      const baseType = mimeType.split(';')[0];
      const fileExtension = (baseType.split('/')[1] || 'webm').toLowerCase();
      formData.append('file', audioBlob, `recording.${fileExtension}`);
      formData.append('model', model);
      formData.append('response_format', responseFormat);

      const response = await fetch(`${API_BASE_URL}/transcribe`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        let errorDetail = '';
        try {
          const data = await response.json();
          errorDetail = data?.detail || JSON.stringify(data);
        } catch (_) {
          errorDetail = await response.text().catch(() => '');
        }
        throw new Error(`Transcription failed: ${response.status} ${response.statusText} ${errorDetail}`);
      }

      const contentType = response.headers.get('content-type') || '';
      let transcription;
      if (contentType.includes('application/json')) {
        const data = await response.json();
        transcription = typeof data === 'string' ? data : (data?.text ?? JSON.stringify(data));
      } else {
        transcription = await response.text();
      }

      // If the backend returned a JSON-serialized string (e.g. "text"), unwrap it
      if (typeof transcription === 'string' && transcription.startsWith('"') && transcription.endsWith('"')) {
        try {
          transcription = JSON.parse(transcription);
        } catch (_) {
          transcription = transcription.slice(1, -1);
        }
      }

      return (transcription || '').trim();
    } catch (error) {
      console.error('Transcription error:', error);
      throw error;
    }
  },
};

export default transcriptionAPI;
